import React from "react";
import { usePreguntasCalidad } from "../../hooks";
import { Preguntas } from "../Preguntas";
import usePreguntasPuntualidad from "../../hooks/usePreguntasPuntualidad";
import usePreguntasComunicacionReportes from "../../hooks/usePreguntasComunicacionReportes";
import usePreguntasResponsabilidadManejoVehiculo from "../../hooks/usePreguntasResponsabilidadManejoVehiculo";
import usePreguntasActitudTrabajoEquipo from "../../hooks/usePreguntasActitudTrabajoEquipo";
import usePreguntasCalidadTrabajo from "../../hooks/usePreguntasCalidadTrabajo";
import usePreguntasResponsabilidadPuntualidad from "../../hooks/usePreguntasResponsabilidadPuntualidad";

const PreguntasResponsabilidadPuntualidad = () => {
	const { frmPreguntas, setPuntajeTotal } = usePreguntasResponsabilidadPuntualidad();

	return (
		<Preguntas
			form={frmPreguntas}
			calcularPuntajeTotal={setPuntajeTotal}
			titulo="Responsabilidad y puntualidad (4/6)"
			opciones={[
				{ key: "llegaPuntualmenteInicioJornada", label: "Llega puntualmente al inicio de la jornada" },
				{ key: "respetaNormasInternasYProtocolosTaller", label: "Respeta las normas internas y protocolos del taller" },
				{ key: "cuidaHerramientasEquiposYEspacioDeTrabajo", label: "Cuida las herramientas, equipos y espacio de trabajo" },
				{ key: "asisteRegularmenteYJustificaAusenciasCorrectamente", label: "Asiste regularmente y justifica ausencias correctamente" }]}
		/>
	);
};

export default PreguntasResponsabilidadPuntualidad;
